<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.KeepAlive"/>
    </keep-alive>

    <router-view v-if="!$route.meta.KeepAlive"/>
    <!--<router-view></router-view>-->
    <van-popup v-model="showLoginDialog">
      <div class="w-300 position-relative h-350 bg-f bdr-15">
        <div class="pd-20 text-strong text-align-center fs-18">登录/注册</div>
        <div class="pd-l-20 pd-r-20">
          <div class="position-relative">
            <van-field v-model="loginForm.phone" type="number" maxlength="11" placeholder="手机号"
                       class="bg-f3f" style="padding-left: 55px!important;"></van-field>
            <div class="position-absolute t-0 l-10 b-0 display-flex align-items-center fs-12" @click="onAreaClick">
              +{{ loginForm.area }}
            </div>
          </div>
          <div class="mg-t-20 position-relative">
            <van-field v-model="loginForm.code" type="number" maxlength="6" placeholder="验证码"
                       class="bg-f3f"></van-field>
            <span @click="onGetCodeClick"
                  class="position-absolute t-0 r-0 pd-15 fs-12 c-app-blue">{{ getSMStxt }}</span>
          </div>
          <div @click="submitLoginForm" class="bg-app-blue text-align-center lh-44 c-f bdr-22 mg-t-20">登录</div>
        </div>
        <div class="mg-t-20 fs-12 text-align-center">
          <div class="justify-content-center align-items-center pd-b-10" @click="agree = !agree">
            <van-checkbox class="mg-r-5" v-model="agree"></van-checkbox>
            已阅读并同意以下协议<br>
          </div>
          <a class="c-app-green" href="https://file.ankichinas.cn/server/index/platformAgreement">用户协议</a>、
          <a class="c-app-green"
             href="https://file.ankichinas.cn/server/index/platformAuthorAgreement">平台创作者协议</a>、
          <a class="c-app-green"
             href="https://file.ankichinas.cn/server/index/platformPurchaserAgreement">消费者权益保障说明</a>
        </div>
        <div class="h-30 loginDialogFooter position-absolute b-30 w-fill"></div>
      </div>
    </van-popup>

    <div @click="commonMask = null" v-if="commonMask" class="position-fixed t-0 b-0 w-fill"
         style="background-color: rgba(0,0,0,0.8);z-index: 99999">
      <div class="text-align-right pd-10">
        <img src="/h5/static/images/course/arrow.png" width="100">
      </div>
      <div class="text-align-center pd-10 c-f">
        <div>{{ commonMask.title }}</div>
        <div>{{ commonMask.desc }}</div>
      </div>
    </div>

    <div @click="wechatShareMask = false" v-if="wechatShareMask" class="position-fixed t-0 b-0 w-fill"
         style="background-color: rgba(0,0,0,0.8);z-index: 99999">
      <div class="text-align-right pd-10">
        <img src="/h5/static/images/course/arrow.png" width="100">
      </div>
      <div class="text-align-center pd-10 c-f">
        <div>请点击右上角菜单分享给好友</div>
      </div>
    </div>

    <div class="position-fixed" id="copy-content" style="bottom: -999px;opacity: 0">{{ copyContent }}</div>
    <div v-if="debugMsg" id="debug-content" class="bg-1 c-f position-fixed t-0 l-0 r-0"
         style="z-index: 999999;max-height: 400px">
      <div v-for="item in debugMsg">{{ item }}</div>
    </div>

    <van-popup v-model="showAreaList" position="bottom">
      <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onAreaConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import request from './libs/api.request'
import util from './libs/util'
import storage from './libs/storage'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      agree: false,
      authToken: '',
      copyContent: '',
      showLoginDialog: false,
      loginUser: null,
      appInner: false,
      getSMStxt: '获取验证码',
      loginForm: {
        area: '86',
        phone: '',
        code: '',
        fromH5: 1,
        wxOpenId: '',
        wxUnionId: '',
      },
      commonMask: null,
      wechatShareMask: false,
      isAndroid: false,
      isIos: false,
      debugMsg: [],
      appVersion: '0',
      wxOpenId: '',
      wxUnionId: '',
      areaList: [
        "86 中国大陆",
        "886 中国台湾",
        "852 中国香港",
        "853 中国澳门",
        "1 加拿大", "1 波多黎各", "1 美国", "7 哈萨克斯坦", "7 俄罗斯", "20 埃及", "27 南非", "30 希腊", "31 荷兰", "32 比利时", "33 法国", "34 西班牙", "36 匈牙利", "40 罗马尼亚", "41 瑞士", "43 奥地利", "44 根西", "44 马恩岛", "44 泽西岛", "44 英国", "45 丹麦", "46 瑞典", "47 挪威", "48 波兰", "49 德国", "51 秘鲁", "52 墨西哥", "53 古巴", "54 阿根廷", "55 巴西", "56 智利", "57 哥伦比亚", "58 委内瑞拉", "60 马来西亚", "61 澳大利亚", "62 印度尼西亚", "63 菲律宾", "64 新西兰", "65 新加坡", "66 泰国", "81 日本", "82 韩国", "84 越南", "90 土耳其", "91 印度", "92 巴基斯坦", "93 阿富汗", "93 意大利", "94 斯里兰卡", "95 缅甸", "98 伊朗", "212 摩洛哥", "213 阿尔格拉", "216 突尼斯", "218 利比亚", "220 冈比亚", "221 塞内加尔", "222 毛里塔尼亚", "223 马里", "224 几内亚", "225 科特迪沃", "226 布基纳法索", "227 尼日尔", "228 多哥", "229 贝宁", "230 毛里求斯", "231 利比里亚", "232 塞拉利昂", "233 加纳", "234 尼日利亚", "235 乍得", "236 中非共和国", "237 喀麦隆", "238 佛得角", "239 圣多美和普林西比", "240 几内亚", "241 加蓬", "242 刚果共和国", "243 刚果民主共和国", "244 安哥拉", "247 阿森松岛", "248 塞舌尔", "249 苏丹", "250 卢旺达", "251 埃塞俄比亚", "253 吉布提", "254 肯尼亚", "255 坦桑尼亚", "256 乌干达", "257 布隆迪", "258 莫桑比克", "260 赞比亚", "261 马达加斯加", "262 马约特", "262 留尼汪", "263 津巴布韦", "264 纳米比亚", "265 马拉维", "266 莱索托", "267 博茨瓦纳", "268 斯威士兰", "269 科摩罗", "297 阿鲁巴", "298 法罗群岛", "299 格陵兰", "350 直布罗陀", "351 葡萄牙", "352 卢森堡", "353 爱尔兰", "354 冰岛", "355 阿尔巴尼亚", "356 马耳他", "357 塞浦路斯", "358 芬兰", "359 保加利亚", "370 立陶宛", "371 拉脱维亚", "372 爱沙尼亚", "373 摩尔多瓦", "374 亚美尼亚", "375 白俄罗斯", "376 安道尔", "377 摩纳哥", "378 圣马力诺", "380 乌克兰", "381 塞尔维亚", "382 黑山", "383 科索沃", "385 克罗地亚", "386 斯洛文尼亚", "387 波斯尼亚和黑塞哥维那", "389 马其顿", "420 捷克共和国", "421 斯洛伐克", "423 列支敦士登", "501 伯利兹", "502 危地马拉", "503 艾萨尔瓦多", "504 洪都拉斯", "505 尼加拉瓜", "506 哥斯达黎加", "507 巴拿马", "509 海地", "590 瓜德罗普", "591 玻利维亚", "592 圭亚那", "593 厄瓜多尔", "594 法属圭亚那", "595 巴拉圭", "596 马提尼克", "597 苏里南", "598 乌拉圭", "599 荷属安的列斯", "670 东帝汶", "673 文莱", "675 巴布亚新几内亚", "676 汤加", "678 瓦努阿图", "679 斐济", "682 库克群岛", "684 萨摩亚东部", "685 萨摩亚西部", "687 新喀里多尼亚", "689 法属波利尼西亚", "855 柬埔寨", "856 老挝", "880 孟加拉国", "960 马尔代夫", "961 黎巴嫩", "962 约旦", "963 叙利亚", "964 伊拉克", "965 科威特", "966 沙特阿拉伯", "967 也门", "968 阿曼", "970 巴勒斯坦", "971 阿拉伯联合酋长国", "972 以色列", "973 巴林", "974 库塔", "975 不丹", "976 蒙古", "977 尼泊尔", "992 塔吉克斯坦", "993 土库曼斯坦", "994 阿塞拜疆", "995 格鲁吉亚", "996 吉尔吉斯斯坦", "998 乌兹别克斯坦", "1242 巴哈马", "1246 巴巴多斯", "1264 安圭拉", "1268 安提瓜和巴布达", "1340 维尔京群岛", "1345 开曼群岛", "1441 百慕大", "1473 格林纳达", "1649 特克斯和凯科斯群岛", "1664 蒙特塞拉特", "1671 关岛", "1758 圣卢西亚", "1767 多米尼加", "1784 圣文森特", "1809 多米尼加共和国", "1868 特立尼达和多巴哥", "1869 圣基茨和尼维斯", "1876 牙买加"
      ],
      showAreaList: false,
    }
  },
  methods: {
    debug(msg) {
      if (typeof (msg) != 'string')
        msg = JSON.stringify(msg);
      process.env.NODE_ENV === "development" && this.debugMsg.push(msg)
    },
    login() {
      if (this.appInner && this.isIos) {
        if (akBridge) {
          akBridge.callHandler("akUserLogin");
        } else {
          this.$toast('调起登录异常');
        }
      } else {
        this.showLoginDialog = true;
      }
    },
    execCopy(content, successMessage, callback) {
      this.copyContent = content;
      setTimeout(() => {
        const range = document.createRange();
        range.selectNode(document.getElementById('copy-content'));
        const selection = window.getSelection();
        if (selection.rangeCount > 0) selection.removeAllRanges();
        selection.addRange(range);
        console.log(this.copyContent);
        document.execCommand('copy');
        if (successMessage !== false) {
          this.$toast(successMessage);
        }
        if (callback) {
          callback();
        }
      }, 150);
    },

    showCommonMask(title, desc) {
      this.commonMask = {title, desc};
    },
    showWechatShareMask() {
      this.wechatShareMask = true;
    },
    onGetCodeClick() {
      if (this.getSMStxt !== "获取验证码") {
        return;
      }

      if (this.loginForm.area == '86' && this.loginForm.phone.length != 11) {
        this.$toast('请输入11位手机号');
        return;
      }

      let timer = 60;
      this.getSMStxt = timer + "s 重新获取";
      let interval = setInterval(() => {
        if (timer > 0) {
          timer--;
          this.getSMStxt = timer + "s 重新获取";
        } else {
          this.getSMStxt = "获取验证码"
          clearInterval(interval)
        }
      }, 1000);
      request.request({
        url: "/common/getSmsCode",
        params: {
          phone: this.loginForm.phone,
          type: 'login'
        }
      }).then((data) => {
        console.log(data);
      }).catch((e)=>{
        this.$toast(e);
        this.getSMStxt = "获取验证码"
        clearInterval(interval)
      });
    },
    submitLoginForm() {
      if (!this.agree) {
        this.$toast('需同意用户协议和隐私政策');
        return;
      }
      this.$toast.loading({message: '', duration: 60000, overlay: true});
      this.loginForm.wxUnionId = this.wxUnionId;
      this.loginForm.wxOpenId = this.wxOpenId;
      request.request({url: '/user/loginByPhone2', data: this.loginForm, method: 'post'}).then((data) => {
        this.$toast.clear();
        this.$cookies.set('authToken', data.token, 86400 * 90);
        storage.setUserInfo(data.userInfo);
        this.$toast('登录成功！');
        let newUrl = location.href.replace('app-token=logout', 'app-token=');
        setTimeout(() => {
          location.replace(newUrl);
        }, 1000)
      }).catch(err => {
        this.$toast.clear();
        setTimeout(() => {
          this.$toast(err.message);
        }, 200);
      })
    },
    fetchServerUserInfo() {
      let requestStatus = 0;
      setTimeout(() => {
        if (requestStatus === 0) {
          this.$toast.loading({message: '', duration: 60000, overlay: true});
        }
      }, 800);
      request.request({
        url: 'user/getInfo'
      }).then(data => {
        requestStatus = 1;
        this.$toast.clear();
        this.loginUser = data;
        storage.setUserInfo(data)
      }).catch((err) => {
        requestStatus = 1;
        this.$toast.clear();
        if (err && err.code > 400 && err.code < 404) {
          this.$toast('登录已过期，请重新登录');
          this.loginUser = null;
          storage.setUserInfo(null);
          this.$cookies.remove('authToken')
        } else {
          this.$dialog.alert({message: err.message ? err.message : '请检查网络！'}).then(() => {
            location.reload()
          })
        }
      })
    },
    doWxShare(title, desc, link, thumb) {
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: title,
          desc: desc,
          link: link,
          imgUrl: thumb,
          success: () => {

          }
        });

        wx.updateTimelineShareData({
          title: title,
          link: link,
          imgUrl: thumb,
          success: () => {
            // 设置成功
          }
        })
      });
      request.request({
        url: 'wx/config',
        method: 'post',
        data: {
          url: location.href,
        },
      }).then((data) => {
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
        });

      });
    },
    onAreaClick() {
      this.showAreaList = true;
    },
    onAreaConfirm(value, index) {
      this.loginForm.area = this.areaList[index].split(' ')[0];
      this.showAreaList = false;
    }
  },
  mounted() {
    if (this.authToken) {
      this.fetchServerUserInfo();
    }
  },
  created() {
    if (navigator.userAgent.toLowerCase().indexOf('ipad') > -1
        || navigator.userAgent.toLowerCase().indexOf('mac os') > -1
        || navigator.userAgent.toLowerCase().indexOf('iphone') > -1
        || navigator.userAgent.toLowerCase().indexOf('safari') > -1
    ) {
      this.isIos = true;
      this.isAndroid = false;
    }

    if (
        navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('xiaomi') > -1
    ) {
      this.isAndroid = true;
      this.isIos = false;
    }

    console.log("this.isIos", this.isIos);
    console.log("this.isAndroid", this.isAndroid);
    localStorage.setItem('appOs', this.isIos ? 'ios' : 'android');

    this.loginUser = storage.getUserInfo();

    if (util.inWechat()) {
      let loadJS = (id, fileUrl) => {
        var scriptTag = document.getElementById(id);
        var oHead = document.getElementsByTagName('HEAD').item(0);
        var oScript = document.createElement("script");
        if (scriptTag) oHead.removeChild(scriptTag);
        oScript.id = id;
        oScript.type = "text/javascript";
        oScript.src = fileUrl;
        oHead.appendChild(oScript);
      }
      loadJS('wxjs', "https://res2.wx.qq.com/open/js/jweixin-1.6.0.js");
      this.wxOpenId = sessionStorage.getItem('wx_open_id');
      this.wxUnionId = sessionStorage.getItem('wx_union_id');
      if (!this.wxOpenId) {
        if (this.$route.query && this.$route.query.code) {
          this.$toast.loading({message: '请稍候', duration: 8000, overlay: true});
          request.request({
            url: '/common/getWxgzhInfoByCode?code=' + this.$route.query.code
          }).then(data => {
            this.$toast.clear();
            sessionStorage.setItem('wx_open_id', data.wxOpenId);
            sessionStorage.setItem('wx_union_id', data.wxUnionId);
            this.wxOpenId = data.wxOpenId;
            this.wxUnionId = data.wxUnionId;
            if (!this.authToken && data.token) {
              this.authToken = data.token;
              this.$cookies.set('authToken', data.token, 86400 * 90);
              storage.setUserInfo(data.userInfo);
              location.reload();
            }
          }).catch((err) => {
            this.$toast.clear();
            if (err.code == 401) {
              location.replace(location.href.replace("code=" + this.$route.query.code, "1=1"));
            } else {
              this.$dialog.alert({message: '微信授权失败了，点击确定刷新页面，如有问题请联系Anki记忆卡技术支持！'}).then(() => {
                location.replace(location.href.replace("code=" + this.$route.query.code, "1=1"));
              })
            }
          });
        } else {
          let url = "https://file.ankichinas.cn/server/api/common/wxgzhAuthBase?url=" + encodeURIComponent(location.href);
          console.log(url);
          location.href = url;
          return;
        }
      }
    }


    let appInner = this.$route.query['app-inner'];
    this.appVersion = this.$route.query['app-version'];
    if (this.appVersion) {
      localStorage.setItem('appVersion', this.appVersion)
    } else {
      if (localStorage.getItem('appVersion')) {
        this.appVersion = localStorage.getItem('appVersion');
      } else {
        this.appVersion = '1.0.0';
      }
    }
    if (appInner) {
      if (appInner === 'yes') {
        this.$cookies.set('appInner', appInner, 3600 * 9);
      } else {
        this.$cookies.remove('appInner');
      }
    }
    this.appInner = this.$cookies.get('appInner') === 'yes';
    this.authToken = this.$cookies.get('authToken');
    sessionStorage.setItem('isAndroid', this.isAndroid ? 'yes' : 'no');
    sessionStorage.setItem('isIos', this.isIos ? 'yes' : 'no');
    let appToken = this.$route.query['app-token'];
    if (appToken === 'logout') {

      /**
       * ignoreLogout 用于忽略app-token=logout，比如登录成功刷新页面时url可能携带 app-token=logout而导致登录态被错误的清理
       */
      if (this.$cookies.get('ignoreLogout') === 'yes') {
        this.$cookies.remove('ignoreLogout')
      } else {
        this.$cookies.remove('authToken');
        this.authToken = '';
        storage.setUserInfo(null)
      }
    } else {
      if (appToken && this.authToken !== appToken) {
        this.authToken = appToken;
      }
    }
    if (this.authToken) {
      this.$cookies.set('authToken', this.authToken, 86400 * 90);
    }

    setTimeout(() => {
      if (akBridge) {
        this.appInner = true;
        akBridge.registerHandler("akUserLoginSuccess", (appToken) => {
          this.$cookies.set('authToken', appToken, 86400 * 90);
          let newUrl = location.href.replace('app-token=logout', 'app-token=');
          setTimeout(() => {
            location.replace(newUrl);
          }, 200)
        });
      }
    }, 200)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.loginDialogFooter {
  margin-bottom: -30px;
  background-image: url('./assets/login-dialog-bg.png');
  background-repeat: repeat-x;
  background-size: auto 100%;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.van-popup {
  background-color: transparent !important;
}
</style>
